<template>
  <el-container class="reports">
    <!-- <SidebarMenus v-show="$route.meta.showFather" /> -->
    <el-container
      class="main-container"
      v-show="$route.meta.showFather"
    >
      <!-- <el-header class="header">
        <div class="header-content">
          <img
            src="../../../assets/logo-text.png"
            alt="OxpeckerLogo"
            class="logo"
          />
          <div class="user-info">
            <UserButton />
          </div>
        </div>
      </el-header> -->
      <el-main class="main-content">
        <div class="content-header">
          <h2>
            <img src="@assets/codeScan/code_scan_sj.png" />
            {{$t('reports.title')}}
          </h2>

          <el-button
            type="primary"
            class="new-scan-button"
            @click="handleShareListClick"
            icon="el-icon-share"
          >{{ $t('reports.shareList') }}</el-button>
        </div>
        <div class="filter-container">
          <img
            src="../../../assets/codeScan/notification-icon-filter.png"
            alt="Filter Icon"
            class="filter-icon"
          />
          <el-form
            :model="searchForm"
            :inline="true"
            label-width="100px"
            :show-message="false"
          >
            <el-form-item :label="$t('reports.projectName')">
              <el-input
                size="small"
                v-model="searchForm.projectName"
                :placeholder="$t('reports.search')"
                class="filter-input"
                clearable
              />
            </el-form-item>
            <el-form-item :label="$t('reports.createdOn')">
              <el-date-picker
                v-model="searchForm.createdOn"
                size="small"
                type="daterange"
                :start-placeholder="$t('reports.startDate')"
                :end-placeholder="$t('reports.endDate')"
                value-format="MM-dd-yyyy"
              ></el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('reports.taskStatus')">
              <el-select
                v-model="searchForm.taskStatus"
                :placeholder="$t('reports.select')"
                size="small"
                clearable
              >
                <el-option
                  v-for="item in taskStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <el-button
            type="primary"
            size="small"
            @click="handleSearch"
          >{{ $t('reports.searchButton') }}</el-button>
          <el-button
            type="primary"
            class="new-scan-button"
            :loading="batchDeleteLoading"
            :disabled="selectedProjects.length === 0"
            @click="deleteClick"
          >{{ $t('reports.deleteBtn') }}</el-button>
        </div>
        <el-table
          :data="projects"
          style="width: 100%"
          v-loading="tableLoading"
          @selection-change="handleSelectionChange"
          :row-class-name="tableRowClassName"
          column-key="taskId"
        >
          <el-table-column
            type="selection"
            width="55"
          />
          <el-table-column
            prop="projectName"
            :label="$t('reports.projectName')"
          >
            <template slot-scope="scope">
              {{ scope.row.projectName || $t('reports.na') }}
            </template>
          </el-table-column>
          <el-table-column
            prop="createdAt"
            :label="$t('reports.createdOn')"
          >
            <template slot-scope="scope">
              {{ dateFormat(scope.row.createdAt) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="report"
            :label="$t('reports.report')"
          >
            <template slot-scope="scope">
              <el-tag
                :type="getStatusTagType(scope.row.taskStatus)"
                size="small"
                :style="scope.row.taskStatus === 'SUCCESS' ? 'cursor: pointer' : 'cursor: not-allowed'"
                :class="{'black-background': scope.row.taskStatus === 'SUCCESS'}"
                @click="handleReportClick(scope.row)"
              >
                {{ scope.row.taskStatus === 'SUCCESS' ? $t('reports.view') : taskStatusOptions.find(item => item.value === scope.row.taskStatus)?.label }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="vulnerability"
            :label="$t('reports.vulnerability')"
          >
            <template slot-scope="scope">
              <VueStat
                :vulStat="scope.row.resultsStat"
                @click="(vul) => handleVulTagClick(vul, scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="Purchase"
            :label="$t('reports.purchase')"
          >
            <template slot-scope="scope">
              <span>{{ `${scope.row.resultsStat?.['purchased'] || 0}/${scope.row.resultsStat?.['total'] || 0}`  }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('reports.delete')">
            <template slot-scope="scope">
              <img
                class="bookmark"
                src="@assets/codeScan/notification-icon-del.png"
                alt=""
                @click="handleDelete(scope.row)"
              />
              <!-- <el-button icon="el-icon-delete-solid" @click="handleDelete(scope.$index)"></el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <el-footer style="height:auto">
          <el-pagination
            :current-page="queryForm.pageNo"
            :layout="layout"
            :pager-count="5"
            :page-size="queryForm.pageSize"
            :total="total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </el-footer>
      </el-main>
    </el-container>
    <router-view></router-view>
    <el-dialog
      :visible.sync="deleteVisible"
      width="500px"
      :title="$t('reports.deleteTask')"
    >
      <div style="text-align: center; font-size: 18px">{{ $t('reports.deleteConfirmation') }} <span style="font-weight: bold;">{{deleteTaskName}}</span> ?</div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="deleteVisible = false">{{ $t('reports.cancel') }}</el-button>
        <el-button
          type="primary"
          @click="confirmDelete"
        >{{ $t('reports.confirm') }}</el-button>
      </span>
    </el-dialog>
    <ShareList
      v-if="shareListVisible"
      :visible="shareListVisible"
      @close="shareListVisible = false"
    />
  </el-container>
</template>

<script>
// import SidebarMenus from '@/components/SidebarMenus.vue';
// import UserButton from '@/components/user-button.vue';
import VueStat from '@/components/vul-stat.vue';
import { getTaskList, deleteTask } from '@/api/base';
import { mapGetters } from 'vuex';
import { dateLocaleFormat, utcDateFormat } from '@/lib/date-format';
import { TaskStatusOptions } from '@/enum';
import ShareList from '@/views/Reports/_components/share-list.vue';

export default {
  name: 'ReportsIndex',
  components: {
    // SidebarMenus,
    // UserButton,
    VueStat,
    ShareList,
  },
  data() {
    return {
      deleteVisible: false,
      batchDeleteLoading: false,
      taskStatusOptions: Object.freeze(TaskStatusOptions),
      searchForm: {
        projectName: '',
        createdOn: [],
        taskStatus: '',
      },
      selectedFilters: [],
      selectedDate: null,
      showDatePicker: false,
      layout: 'prev, pager, next, total, jumper',
      total: 0,
      queryForm: {
        pageNo: 1,
        pageSize: 10,
      },
      currentPage: 1,
      tableLoading: true,
      filter: '',
      selectedProjects: [],
      projects: [],
      deletedTaskList: [],
      shareListVisible: false,
    };
  },
  computed: {
    ...mapGetters('common', ['locale']),
    deleteTaskName() {
      return this.deletedTaskList.map((item) => item.projectName).join(', ');
    },
  },
  mounted() {
    this.getTaskList();
  },
  methods: {
    handleSearch() {
      const filters = [];

      if (this.searchForm.projectName) {
        filters.push({
          field: 'projectName',
          op: 'LIKE',
          value: this.searchForm.projectName,
        });
      }

      if (this.searchForm.createdOn && this.searchForm.createdOn.length) {
        filters.push(
          {
            field: 'createdAt',
            op: 'LE',
            value: utcDateFormat(this.searchForm.createdOn[1]),
          },
          {
            field: 'createdAt',
            op: 'GT',
            value: utcDateFormat(this.searchForm.createdOn[0]),
          }
        );
      }

      if (this.searchForm.taskStatus) {
        filters.push({
          field: 'taskStatus',
          op: 'EQ',
          value: this.searchForm.taskStatus,
        });
      }

      this.getTaskList(filters);
    },
    dateFormat(date) {
      return dateLocaleFormat(date, this.locale);
    },
    // 列表接口
    getTaskList(filters = []) {
      this.tableLoading = true;
      const params = {
        page: this.queryForm.pageNo - 1,
        size: this.queryForm.pageSize,
        filters,
      };

      getTaskList(params)
        .then((res) => {
          this.projects = res.data;
          this.total = res.total;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    handleFilterChange(value) {
      const index = value.indexOf('createBefore');
      if (index !== -1) {
        this.filterIndex = index;
        this.selectedFilters = this.selectedFilters.filter((item) => item !== 'createBefore');
        this.showDatePicker = true; // 显示日期选择器
        this.$nextTick(() => {
          this.$refs.filterSelect.blur(); // 手动关闭下拉框
          if (this.$refs.hiddenDatePicker) {
            this.$refs.hiddenDatePicker.showPicker(); // 手动触发日期选择器
          } else {
            console.error('Cannot find hiddenDatePicker ref');
          }
        });
      }
    },
    handleDateChange(date) {
      this.selectedDate = date;
      this.showDatePicker = false;

      // 检查是否已经存在日期
      const createBeforeIndex = this.selectedFilters.findIndex((item) => !isNaN(Date.parse(item)));
      if (createBeforeIndex !== -1) {
        // 覆盖之前的日期选择
        this.selectedFilters.splice(createBeforeIndex, 1, this.selectedDate);
      } else {
        // 添加新的日期选择
        this.selectedFilters.push(this.selectedDate);
      }

      // 在这里你可以处理用户选择的日期
      console.log('Selected date is: ' + this.selectedDate);
    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.handleSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNo = val;
      this.handleSearch();
    },
    handleDelete(row) {
      this.deletedTaskList = [row];
      this.deleteVisible = true;
    },
    handleSelectionChange(val) {
      this.selectedProjects = val;
    },
    getStatusTagType(status) {
      switch (status) {
        case 'FAILED':
          return 'danger';
        case 'SUCCESS':
          return 'success';
        default:
          return 'info';
      }
    },
    tableRowClassName({ row }) {
      if (this.selectedProjects.includes(row)) {
        return 'selected-row';
      }
      return '';
    },
    getVulnTagType(key) {
      switch (key) {
        case 'criticalCount':
          return 'info';
        case 'highCount':
          return 'danger';
        case 'Medium-High':
          return 'warning';
        case 'mediumCount':
          return 'primary';
        case 'lowCount':
          return 'success';
        default:
          return 'default';
      }
    },
    handleReportClick(row) {
      if (row.taskStatus === 'SUCCESS') {
        // this.$router.push('/reports-view');
        this.$router.push({
          name: 'ReportsView',
          query: {
            taskId: row.taskId,
          },
        });
      }
    },
    deleteClick() {
      this.deletedTaskList = this.selectedProjects;
      this.deleteVisible = true;
    },
    confirmDelete() {
      this.deleteVisible = false;

      if (this.deletedTaskList.length) {
        const taskIds = this.deletedTaskList.map((item) => item.taskId);

        this.batchDeleteLoading = true;

        deleteTask({ taskIds })
          .then(() => {
            this.$message.success(this.$t('reports.deleteSuccess'));
            this.handleSearch();
          })
          .catch(() => {
            this.$message.error(this.$t('reports.deleteFailed'));
          })
          .finally(() => {
            this.batchDeleteLoading = false;
          });
      }
    },
    handleVulTagClick(vul, row) {
      this.$router.push({
        name: 'ReportsView',
        query: {
          taskId: row.taskId,
          severity: vul.severity,
        },
      });
    },
    handleShareListClick() {
      this.shareListVisible = true;
    },
  },
};
</script>

<style lang="scss">
.reports {
  width: 100%;
  display: flex;
  // background-color: #f5f5f5;
  border-radius: 10px;

  .el-form-item {
    margin-bottom: 0;
  }

  .main-container {
    display: flex;
    flex-direction: column;
    width: calc(100% - 80px);
  }

  .sidebar {
    height: calc(100vh - 85px);
    margin: 60px 0px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
  }

  .el-menu {
    background: linear-gradient(to bottom, #e9eef2, #fff);
    height: calc(100vh - 85px);
    border-radius: 10px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: #fff;
    margin: 0;
    border-radius: 10px;
    width: 100%;
    position: absolute;
    top: 0px;
    right: 0px;
  }

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .main-content {
    flex: 1;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .underImgView {
    width: 20px;
    height: 20px;
    cursor: pointer;
    position: relative;
    top: 5px;
    left: 10px;
  }

  .el-footer {
    display: flex;
    justify-content: right;
    margin-top: 18px;
  }

  .logo {
    width: 150px;
  }

  .user-info {
    display: flex;
    align-items: center;
  }

  .username {
    margin-right: 10px;
  }

  .user-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  .content-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    background-color: #e1e8ed;
    border-radius: 10px;
    padding: 0px 20px;
    height: 55px;

    img {
      position: relative;
      top: 0;
      margin-right: 8px;
    }

    h2 {
      display: flex;
      align-items: center;
      font-size: 20px;
    }

    .el-breadcrumb {
      font-size: 17px;
      margin: 0px 15px;
      position: relative;
      top: 2px;
    }
  }

  .new-scan-button {
    background-color: #000;
    color: #fff;
    border: 2px solid #000;
    width: 120px;
    height: 35px;
    line-height: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto !important;
  }

  .filter-container {
    display: flex;
    align-items: center;
    margin: 20px 20px;
  }

  .filter-icon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  .filter-select {
    flex: 1;
    margin-right: 10px;
  }

  .bookmark {
    cursor: pointer;
    width: 30px;
    height: 30px;
  }

  .el-table th.el-table__cell {
    background-color: #eeeeee;
  }

  .black-background {
    background-color: #000 !important;
    color: #fff !important;
    border-radius: 5px;
    cursor: pointer;
  }

  .gray-background {
    background-color: #ccc !important;
    color: #fff !important;
    border-radius: 5px;
    cursor: not-allowed;
  }

  .vulnerability-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    width: 200px;

    .el-tag--dark.el-tag--info {
      background-color: #951d1d;
      border-color: #951d1d;
      color: #fff;
    }
  }
}
</style>